import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import * as React from 'react';
import { IconClock } from '@tock/icons';
import { IconClock as IconClockLegacy } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { Typography } from 'omakase';
import NewlineEscapedText from '@tock/shared/components/NewlineEscapedText';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    highlightedNote: {
      alignItems: 'center',
      backgroundColor: theme.colors.bgLight,
      borderRadius: 3,
      display: 'flex',
      marginBottom: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
  })
);

interface Props {
  body?: string;
  highlightedNote?: JSX.Element | string;
  showBody?: boolean;
  showReleasesInfo?: boolean;
}

export const CardContentDetails: React.FunctionComponent<Props> = ({
  body,
  showBody,
  highlightedNote,
  showReleasesInfo,
}) => {
  const classes = useStyles();

  if (!(body && showBody) && !(highlightedNote && showReleasesInfo)) {
    return null;
  }

  return (
    <section>
      {highlightedNote && showReleasesInfo && (
        <section className={classes.highlightedNote}>
          <IconMigrationUtil
            legacyIcon={<IconClockLegacy fontSize="small" />}
            newIcon={<IconClock fontSize="small" />}
          />
          <Typography component="h2" variant="body02Strong">
            {highlightedNote}
          </Typography>
        </section>
      )}
      {body && showBody && (
        <Typography component="span" aria-hidden="true" variant="caption">
          <NewlineEscapedText text={body} />
        </Typography>
      )}
    </section>
  );
};
